import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import './utils/rem'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/element-variables.scss';
Vue.config.productionTip = false
Vue.use(ElementUI);
// main.js
Vue.prototype.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
